<template>
  <tg-layout>
    <template slot="header">
      <portal to="tools" :disabled="!isMobile">
        <tg-search-tool :data="searchData" @on-submit="handleSearch">
          <el-input
            :placeholder="placeholder"
            v-model="searchData.targetName"
            class="tg-input"
            size="small"
            style="width: 160px"
            clearable
          ></el-input>
        </tg-search-tool>
      </portal>
    </template>

    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      showPagination
      :header-cell-class-name="addLockColumns"
      @on-loaded="handleLoaded"
    >
      <template slot="userfullname" slot-scope="scope">
        {{ scope.row["username"] }} ({{
        scope.row["usernickname"]
        }})
      </template>

      <template slot="belows" slot-scope="scope">
        <tg-below-cell
          :group="scope.row['group']"
          :row="scope.row"
          @on-click="handleBelowClick"
        ></tg-below-cell>
      </template>

      <template slot="statusBtn" slot-scope="scope">
        <tg-status-btn
          :status="scope.value"
          :disabled="!scope.column.enable_change || isSub"
          @on-click="
              handlePrivilegeStatusChange(scope.column, scope.value, scope.row)
            "
          @on-click-disabled="
              handlePrivilegeStatusChange(
                scope.column,
                scope.value,
                scope.row,
                true
              )
            "
        ></tg-status-btn>
      </template>
    </tg-table>

    <tg-privilege-change-dialog
      :visible.sync="showPrivilegeChangeDialog"
      v-bind="privilegeChgDialog"
      :role="project"
      @on-changed="handlePrivilegeChanged"
    ></tg-privilege-change-dialog>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTable from "@/components/table/TgTable";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgStatusBtn from "@/components/button/TgStatusBtn";
import TgPrivilegeChangeDialog from "@/components/dialog/TgPrivilegeChangeDialog";
import TgBelowCell from "@/components/slot/TgBelowCell";

import apis from "@/apis";
import str from "@/utils/str";

const api = apis.tg_business;

export default {
  components: {
    TgLayout,
    TgTable,
    TgSearchTool,
    TgStatusBtn,
    TgPrivilegeChangeDialog,
    TgBelowCell,
  },
  data() {
    return {
      searchData: {},
      columns: [],
      showPrivilegeChangeDialog: false,
      privilegeChgDialog: {
        item: {},
        username: "",
      },
      parent: {
        username: '',
        group: ''
      },
      hasBelowColumns: [],
      noBelowColumns: [],
      n: 0
    };
  },
  props: {
    project: String,
    hasUser: Boolean,
  },
  created() {
    if (this.$route.params.username && !this.parent.username) {
      this.$router.push({ name: "tg_business.agent.privilege.index" });
    }
    this.fetchColumns(this.project);
  },
  computed: {
    proxy() {
      return api[this.project].privilege.getData;
    },
    placeholder() {
      return this.$t("component.form.input.placeholder." + this.project);
    },
    request() {
      return {...this.searchData, parent_username: this.parent.username};
    }
  },
  methods: {
    fetchColumns(project) {
      api[project].privilege.getColumns().then((response) => {
        this.columns = response.data;
        this.hasBelowColumns = response.data;
        this.noBelowColumns = response.data.filter(x => x.name != 'belows');
        this.$refs.table.init(this.request);
      });
    },
    handleSearch() {
      this.parent.username = '';
      this.parent.group = '';

      if (this.$route.params.username) {
        this.$store.commit("breadcrumb/clear");

        this.$router.push({
          name: 'tg_business.agent.privilege.index',
          params: {
            username: ''
          }
        });
      } else {
        this.$refs.table.search(this.request);
      }
    },
    handleLoaded(response) {
      let hasBelows = response.data.length > 0 && response.data[0].belows.length > 0;

      let columns = JSON.parse(
          JSON.stringify(hasBelows ? this.hasBelowColumns : this.noBelowColumns)
        );
        columns[0].langKey = 'l' + response.data[0].group + "_account";
      this.columns = columns;

      this.$nextTick(() => {
          if (this.$route.params.username) {
            this.addBreadcrumb(response);
          } else {
            this.$store.commit("breadcrumb/clear");
          }
        });
    },
    addBreadcrumb(response) {
      let upperGroupTag = "l" + response.upper_group;

      let title = str.format(
        "{0} ({1})",
        this.$t("column." + upperGroupTag),
        this.$route.params.username
      );

      this.$store.commit("breadcrumb/add", {
        id: "agent-privilege.user_" + this.$route.params.username,
        name: "agent-privilege.user",
        query: {
          ...this.$route.query,
        },
        params: {
          username: this.$route.params.username,
        },
        meta: {
          title: title,
        },
      });
    },
    handlePrivilegeStatusChange(column, status, row, noPrivilege) {
      let type = column.privilege_type;
      let privilege = column.privilege_item;

      let dialog = {
        item: {
          status,
          privilege,
          type,
          label: column.parent
            ? column.parent.title + "-" + column.title
            : column.title,
        },
        username: row["username"],
        noPrivilege,
      };

      this.privilegeChgDialog = dialog;

      this.showPrivilegeChangeDialog = true;
    },
    handlePrivilegeChanged() {
      this.$refs.table.refresh();
    },
    addLockColumns({ column }) {
      let col = this.$refs.table.allColumns.find(
        (x) => x.name === column.columnKey
      );

      if (!col || col.slot !== "statusBtn") {
        return "";
      }

      return col.enable_change == false ? "locked" : "";
    },
    handleBelowClick({ row }) {
      this.parent.username = row.username;
      this.parent.group = row.group;
      this.searchData.username = "";
      let route = "tg_business.agent.privilege.user";
      
      this.$nextTick(() => {
        this.$router.push({
          name: route,
          params: {
            username: row["username"],
          },
        });
      });
      
    },
    togglePage(hasUser) {
      if (hasUser) {
        this.$refs.table.search(this.request);
      } else {
        this.parent.username = '';
        this.parent.group = '';
        this.$store.commit("breadcrumb/clear");
        this.$refs.table.search(this.searchData);
      }
    }
  },
  watch: {
    project(value) {
      this.fetchColumns(value);
      this.searchData = {};
      this.showPrivilegeChangeDialog = false;
    },
    hasUser(val) {
      this.togglePage(val, this.$route);
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.togglePage(to.params.username, to);
    next();
  },
};
</script>
